import {createSlice, createAsyncThunk} from '@reduxjs/toolkit';
import {validateFields, validateField} from '../../../../utilities/validation/validator';
import ProviderManager from '../../../../provider/providerManager';
import lodash from 'lodash';

export const emailIsExist = createAsyncThunk('customeremail/emailIsExist', async (data, thunkAPI) => {
  try {
    const result = await ProviderManager.getProviderData('emailIsExist', [data.eMailAddress]);
    return result;
  } catch (error) {
    return error;
  }
});

const initialState = {
  form: {
    email: '',
    valid: '',

    errors: {
      email: '',
    },
    rules: {},
  },
  isEmailFree: '',
  isReceivingBill: true,
}

const customerEmailSlice = createSlice({
  name: 'customeremail',
  initialState: initialState,

  reducers: {
    resetState: (state) => initialState,
    setCustomerEmail: (state, action) => {
      if (action.payload) {
        state.form.email = action.payload;
      } else {
        state.form.email = '';
      }
    },
    clearValid: {
      reducer(state, action) {
        state.form.valid = '';
        state.isEmailFree = '';
      },
    },
    setEmailIfCustomerExist: (state, action) => {
      state.isEmailFree = action.payload;
    },

    validateHandler: {
      reducer(state, action) {
        state.form = action.payload;
      },
      prepare(payload) {
        const validate = validateFields(lodash.cloneDeep(payload));
        return {payload: validate};
      },
    },
    reportAnalytics: (state, action) => {},
    clearIsValid: {
      reducer(state, action) {
        state.form.valid = '';
      },
    },
    changeHandler: {
      reducer(state, action) {
        state.form = action.payload;
        if (!state.isEmailFree) {
          state.isEmailFree = '';
        }
      },
      prepare(payload) {
        const name = payload.target.name;
        const value = payload.target.value;
        const form = lodash.cloneDeep(payload.form);
        const validate = validateField(form, name, value);
        return {payload: validate};
      },
    },
    setReceivingBill: {
      reducer(state, action) {
        if (state.isReceivingBill) {
          state.isReceivingBill = false;
        } else {
          state.isReceivingBill = true;
        }
      },
    },
  },

  extraReducers: {
    [emailIsExist.fulfilled]: (state, action) => {
      state.isEmailFree = action.payload.Body.isSuccess;
    },
  },
});

export const {
  changeHandler,
  validateHandler,
  setCustomerEmail,
  setEmailIfCustomerExist,
  setReceivingBill,
  clearValid,
  reportAnalytics,
  resetState
} = customerEmailSlice.actions;

export default customerEmailSlice.reducer;
